import { ProfileDoneParticleImage } from '@local/assets/images'

import ProfileThumbnail from '@web/components/ProfileThumbnail'
import Clickable from '@web/ui/components/Clickable'
import Image from '@web/ui/components/Image'

import styles from './ProfileDoneModal.module.scss'

export interface UIPropfileDoneModalProps {
  nickname: string
  profileImageUrl?: string
  hasReview: boolean
  onConfirm?: () => void
}

const UIProfileDoneModal = ({ onConfirm, nickname, profileImageUrl, hasReview }: UIPropfileDoneModalProps) => {
  const welcomeMessage = hasReview ? (
    <>
      <em>{nickname}</em>님, 새로운 프로필로
      <br />
      더욱 활발한 활동 기대할게요!
    </>
  ) : (
    <>
      <em>{nickname}</em>님 반갑습니다!
      <br />
      알차고 멋진 리뷰 기대할게요!
    </>
  )

  return (
    <div className={styles.modal_onboarding_done}>
      <div className={styles.icon_area}>
        <div className={styles.thumb_area}>
          <ProfileThumbnail size={86} thumbnailUrl={profileImageUrl} />
        </div>
        <Image
          className={styles.icon_particle}
          src={ProfileDoneParticleImage.src}
          width={259}
          height={105}
          alt="폭죽 파티클"
        />
      </div>
      <div className={styles.tit_area}>{welcomeMessage}</div>
      <div className={styles.btn_area}>
        <Clickable className={styles.btn} onClick={onConfirm}>
          확인
        </Clickable>
      </div>
    </div>
  )
}

export default UIProfileDoneModal
